<template>
  <div class="match-invite-page page">
    <Breadcrumb></Breadcrumb>
    <!-- 主体 -->
    <div id="108">
      <!-- 公司简介 -->
      <Company></Company>
    </div>
    <div id="109">
      <!-- 管理团队 -->
      <Team></Team>
    </div>
    <div id="110">
      <!-- 发展历程 -->
      <History></History>
    </div>
    <div id="111">
      <!-- 公司荣誉 -->
      <Honors></Honors>
    </div>
    <div id="106">
      <!-- 服务客户 -->
      <Service></Service>
    </div>
    <div id="107">
      <!-- 联系我们 -->
      <ContactUs></ContactUs>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/common/breadcrumb'
import Company from './components/Company.vue'
import Team from './components/Team.vue'
import Honors from './components/Honors.vue'
import Service from './components/Service.vue'
import History from './components/History.vue'
import ContactUs from './components/ContactUs.vue'
import { mapState } from 'vuex'
export default {
  name: 'Policy',
  components: {
    Breadcrumb,
    Company,
    Team,
    Honors,
    Service,
    History,
    ContactUs
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.isMobile // 假设 isMobile 在根 state 下
    })
  },
  data() {
    return {
      categoryId: ''
    }
  },
  watch: {
    '$route.fullPath'() {
      // 路由变化时，重新获取 categoryId 并滚动
      this.categoryId = this.$route.query?.categoryId
      this.$nextTick(() => {
        if (this.categoryId) {
          setTimeout(() => {
            this.scrollToSection(this.categoryId)
          }, 200)
        }
      })
    }
  },
  methods: {
    scrollToSection(sectionId) {
      const el = document.getElementById(sectionId)
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest'
        })
        const offset = !this.isMobile ? 217 : 60
        const top = el.getBoundingClientRect().top + window.pageYOffset - offset
        window.scrollTo({
          top,
          behavior: 'smooth'
        })
      }
    }
  },

  mounted() {
    this.categoryId = this.$route.query?.categoryId
    this.$nextTick(() => {
      if (this.categoryId) {
        setTimeout(() => {
          this.scrollToSection(this.categoryId)
        }, 200)
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.match-invite-page {
  .main {
    flex: 1;
    padding-bottom: 80px;
    background-color: #ffffff;

    .breadcrumb-plate {
      background: linear-gradient(to top, #347cd0 0%, #62a3f0 100%);
      color: #fff;

      display: flex;
      align-items: center;
      padding: 16px 0;
      padding-left: 180px;

      .label {
        line-height: 1;
        font-size: 14px;
      }
    }

    .c-title {
      font-size: 28px;
      padding-left: 17px;
      border-left: 3px solid rgb(12, 108, 228);
      font-weight: 700;
    }
    .english-name {
      color: rgb(153, 153, 153);
      margin-left: 10px;
    }
    .content {
      display: flex;
      justify-content: space-between;
      align-items: stretch;
      margin-top: 30px;
      margin-bottom: 100px;

      .c-top {
        display: flex;
        justify-content: center;
      }

      .c-left {
        flex: 2;
        display: flex;
        justify-content: center;
        background-color: #fff;

        padding-bottom: 70px;

        .picture {
          img {
            width: 280px;
            height: 280px;
          }

          p {
            padding-top: 20px;
            padding-left: 20px;
            font-size: 14px;
            color: #8d8d8d;
          }
        }
      }
      .c-right {
        flex: 1;
        margin-left: 40px;
        .img-wrap {
          img {
            max-width: 100%; /* 最大宽度不超过容器的宽度 */
            max-height: 100%; /* 最大高度不超过容器的高度 */
            object-fit: contain; /* 保持图片的宽高比 */
          }
        }
      }
    }
  }
}
</style>
